module.exports = __webpack_public_path__ + "img/step-icon-profile.9472e2d4.svg";